import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
} from "@mui/material";
import React from "react";

import { DialogHeader } from "../DialogHeader/DialogHeader";

export interface ConfirmDialogProps {
  title: string;
  description: string;
  open: boolean;
  onConfirm: (event: React.MouseEvent) => void;
  onClose: () => void;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  confirmButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    title,
    description,
    open,
    confirmButtonLabel = "Confirm",
    cancelButtonLabel = "Cancel",
    cancelButtonProps,
    confirmButtonProps,
    onConfirm,
    onClose,
  } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader title={title} onClose={onClose} />
      <Divider />
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button color="secondary" {...cancelButtonProps} onClick={onClose}>
          {cancelButtonLabel}
        </Button>
        <Button
          variant="contained"
          {...confirmButtonProps}
          onClick={onConfirm}
          autoFocus
        >
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
